import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

import { TextToPossessivePipeModule } from '@main-client/src/app/pipes/text-to-possessive-pipe/text-to-possessive-pipe.module';

import { SsoSigninComponent } from './sso-signin.component';

@NgModule({
  declarations: [SsoSigninComponent],
  exports: [SsoSigninComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    RouterModule,
    TextToPossessivePipeModule,
  ],
})
export class SsoSigninModule {}
